import { createApp as createVueApp } from 'vue';

export function createApp(...args) {
  const app = createVueApp(...args);
  // vite build sets import.meta.env.DEV false even with --mode development
  if (import.meta.env.MODE === 'development') {
    app.config.performance = true;
  }
  return app;
}
